export const languagesPath = {
  en: {name:"English", value: "en", imagePath: "/images/lang_images/en.svg" },
  de: {name:"Deutsch", value: "de", imagePath: "/images/lang_images/de.svg" },
  es: {name:"Española", value: "es", imagePath: "/images/lang_images/es.svg" },
  it: {name:"Italiano", value: "it", imagePath: "/images/lang_images/it.svg" },
  fr: {name:"Française", value: "fr", imagePath: "/images/lang_images/fr.svg" },
  pt: {name:"Português", value: "pt", imagePath: "/images/lang_images/pt.svg" },
};
